import React from 'react';
import { FormView } from '@bp/components';
import { useEditNode } from './useEditNode';

export const EditNode = () => {
  const props = useEditNode();

  return <FormView {...props} />;
};
